import {ApiUtil} from '../api/ApiUtil'
import {BackendAPI, type CreateReportRequestPayload} from '../api/BackendAPI'
import type {AppDispatch, GetStateFunc} from '../store'
import {ActionUtil} from "./ActionUtil";

/**
 * Report related action types.
 */
export enum ReportActionType {
  REPORT_RESET = 'REPORT_RESET',
  REPORT_PENDING = 'REPORT_PENDING',
  REPORT_FULFILLED = 'REPORT_FULFILLED',
  REPORT_REJECTED = 'REPORT_REJECTED'
}

interface ResetReportAction {
  type: ReportActionType.REPORT_RESET
}

interface LoadReportAction {
  type: ReportActionType.REPORT_PENDING
  payload: {
    email: string
  }
}

interface ReportSuccessAction {
  type: ReportActionType.REPORT_FULFILLED
  payload: {
    email: string
  }
}

interface ReportFailureAction {
  type: ReportActionType.REPORT_REJECTED
  payload: {
    error: string
  }
}

export type ReportAction =
  | ResetReportAction
  | LoadReportAction
  | ReportSuccessAction
  | ReportFailureAction

export function createReport(input: CreateReportRequestPayload) {
  return async (dispatch: AppDispatch, getState: GetStateFunc) => {
    const token = ActionUtil.getToken(getState, 'createReport')
    if (!token) {
      return
    }

    dispatch<ReportAction>(reportPending(input.email))

    const reportRes = await BackendAPI.sendReport(input, token)
    if (reportRes.succeeded) {
      dispatch(reportCreationSucceeded(input.email))
    } else {
      const errMsg = ApiUtil.resolveLocalizedErrorMessage(reportRes)
      dispatch(reportCreationFailed(errMsg))
    }
  }
}

export function resetReportState(): ReportAction {
  return {type: ReportActionType.REPORT_RESET}
}

/* Helper Functions */

function reportPending(email: string): ReportAction {
  return {type: ReportActionType.REPORT_PENDING, payload: {email}}
}

function reportCreationFailed(error: string): ReportAction {
  return {type: ReportActionType.REPORT_REJECTED, payload: {error}}
}

function reportCreationSucceeded(email: string): ReportAction {
  return {type: ReportActionType.REPORT_FULFILLED, payload: {email}}
}
